import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface ImprovementProposalButtonProps {
  id: number;
}

function ImprovementProposalButton({ id }: ImprovementProposalButtonProps) {
  const { t } = useTranslation();
  return (
    <Button
      variant="outline"
      onClick={() => {
        window.open(`/app/improvement-proposals/${id}`, "_blank");
      }}
    >
      {t("improvement-proposal")}
    </Button>
  );
}

export default ImprovementProposalButton;
